/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-extraneous-dependencies */
import Handlebars from 'handlebars';

/**
 * Compile a Handlebars template and run it against `data`.
 *
 * Pass `{ noEscape: true }` when the rendered string is used as plain text
 * (e.g. via Vue's `{{ ... }}` text interpolation). Otherwise Handlebars will
 * HTML-escape values, which in a text context becomes visible as literal
 * entities like `&#x27;` for an apostrophe.
 *
 * Default behaviour is preserved for callers that pipe the output into
 * `v-html` / `:html=` (e.g. `AtomTextRichtext`).
 */
export const compileWithHandlebars = (template, data, options = {}) => {
    const compiledTemplate = Handlebars.compile(template, options);
    return compiledTemplate(data);
};
